/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();





$(document).ready(function () {
  function isMobile() {
    return window.innerWidth <= 768
  }

  $(document).on("click", ".navlink--search", function (e) {
    if (!isMobile()) return
    e.preventDefault()
    $(".add_class").addClass("is-open")
  })

  $(document).on("click", ".search-popdown__close", function (e) {
    if (!isMobile()) return
    e.preventDefault()
    $(".add_class").removeClass("is-open")
  })
})





$(document).on('click', '.ahlGiftPopBtnHld', function () {
        setTimeout(() => {
  document.querySelector('cart-items')?.getCart();
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      document.dispatchEvent(
        new CustomEvent('theme:cart:change', {
          bubbles: true,
          detail: { cartCount: cart.item_count }
        })
      );
    });
      }, 400);
});
